<template>
  <div class="data-interaction">
    <main ref="scrollY">
      <transition-group name="transition" tag="ul">
        <div class="interaction" v-for="(interaction,index) in interactions" :key="interaction.id">
          <div class="title">数据联动{{interactions.length - index}}<span class="del-interactions" @click="delInteractions(index)">-</span></div>
          <div class="content">
           <el-form ref="form" class="form" :model="interaction" label-position="left" label-width="80px" :inline="true">
             <el-form-item label="触发操作" prop="type" :rules=" {required: true, message: '请选择触发操作', trigger: 'change'}">
                <el-select v-model="interaction.type" multiple collapse-tags placeholder="请选择" >
                  <el-option label="新建" value="create"></el-option>
                  <el-option label="修改" value="update"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="触发条件" class="expression-item">
                <div class="calculate" @click="openCalculate(interaction.expression, interaction)" v-html="expressionShow(interaction.expression)">{{interaction.expression}}</div>
              </el-form-item>
              <el-form-item label="目标表" prop="targetTable" :rules=" {required: true, message: '请选择目标表', trigger: 'change'}">
                  <el-select v-model="interaction.targetTable" placeholder="请选择目标表" @change="targetTableChange($event,interaction)" filterable clearable>
                    <el-option v-for="table in formService.options.tables" :key="table.id" :label="table.name" :value="table.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="比对字段" prop="compareField" :rules="{required: true, message: '请选择比对字段', trigger: 'change'}">
                <el-select v-model="interaction.compareField" placeholder="请选择比对字段" filterable clearable>
                  <el-option v-for="option in currentTableOptions(interaction.sourceTable, 'compareField')" :key="option.id" :label="option.name" :value="option.id"></el-option>
                </el-select>
                <el-tooltip class="tooltip" content="选择本表单中的某个字段作为条件与目标表中的主键进行比对." placement="top">
                  <span class="fa fa-question-circle"></span>
                </el-tooltip>
              </el-form-item>
              <el-form-item v-if="formService.schema.tables.length > 1" label="源表单" prop="sourceTable" :rules="{required: true, message: '请选择源表单', trigger: 'change'}">
                <el-select v-model="interaction.sourceTable" placeholder="请选择源表单" filterable clearable @change="resetInteractionFields(interaction)">
                  <el-option v-for="table in sourceTables" :key="table.id" :label="table.name" :value="table.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联动字段" class="item-title"></el-form-item>
              <div class="fields" v-for="(el,i) in interaction.interactionFields" :key="i">
               <el-form-item class="interaction-field" label-width="10px" label=" " :prop="'interactionFields.'+i+'.firstField'" :rules="{required: true, message: '请选择本表字段', trigger: 'change'}">
                  <el-select v-model="el.firstField" placeholder="请选择本表字段" @change="setRelationId($event,el)" filterable clearable>
                    <el-option label="默认值" value="默认值"></el-option>
                    <template v-for="table in currentTableOptions(interaction.sourceTable)">
                      <el-option v-for="column in table.columns" :key="column.id" :label="table.name+'-'+column.name" :value="column.id"></el-option>
                    </template>
                  </el-select>
               </el-form-item>
               <el-form-item class="interaction-field" label-width="10px" label=" " :prop="'interactionFields.'+i+'.secondField'" :rules="{required: true, message: '请选择目标表字段', trigger: 'change'}">
                  <el-select v-model="el.secondField" placeholder="请选择目标表字段" filterable clearable>
                    <el-option
                      v-for="column in interaction.columns"
                      :key="column.id"
                      :disabled="interaction.interactionFields.find(n => n.secondField === column.id) && el.secondField !== column.id"
                      :label="column.name"
                      :value="column.id"></el-option>
                  </el-select>
               </el-form-item>
                <i class="el-icon-minus del-field" @click="delField(interaction,i)"></i>
                <el-input class="default-value" v-if="el.firstField==='默认值'" v-model="el.defaultValue"></el-input>
              </div>
              <i class="el-icon-plus add-field" @click="addField(interaction)">添加联动字段</i>
            </el-form>
          </div>
        </div>
      </transition-group>
    </main>
    <i class="el-icon-plus add-interaction" @click="addInteractions">添加数据联动</i>
  </div>
</template>

<script>
import { dataSourceReport } from './designMixins/mixins'
import { calculateMixin } from '@/components/form/components/mixins'
import CalculationPanel from '@/components/shared/calculation-panel.vue'
import { UUID } from '@/plugins/common'
export default {
  name: 'DataInteractions',
  mixins: [ calculateMixin, dataSourceReport ],
  inject: [ 'formService' ],
  props: ['linkages'],
  components: {
    CalculationPanel
  },
  data () {
    let sourceTables = []
    let dataSourceTable = this.$_.cloneDeep(this.formService.schema.tables) || []
    sourceTables = dataSourceTable.map((t, index) => {
      // 没有主表id说明是新建操作, 将默认没有pinyinName的作为主表单,并且将tableId置为'mainTableId'(后端以此字段作为主表id)
      if ((!this.formService.formMainTableId && !t.pinyinName) || t.tableId === this.formService.formMainTableId) {
        t.name = '主表单'
        t.mainFlag = true
        this.formService.formMainTableId = t.tableId
        t.tableId = 'mainTableId'
      }
      return {name: t.name, id: t.tableId, isMainTable: t.mainFlag || ''}
    })
    // 兼容没有选择过源表单的历史数据,默认为主表单
    this.linkages.forEach(linkage => {
      if (!('sourceTable' in linkage) || !linkage.sourceTable) {
        linkage.sourceTable = 'mainTableId'
      }
    })
    let mainTableId = sourceTables.find(e => e.isMainTable).id
    return {
      mainTableId: mainTableId,
      interactions: this.linkages,
      sourceTables: sourceTables
    }
  },
  created () {
    this.loadColumns()
  },
  computed: {
    currentTableOptions (sourceTableId, type) {
      return function (sourceTableId, type) {
        if (sourceTableId === 'mainTableId') {
          sourceTableId = this.formService.formMainTableId
        }
        if (type === 'compareField') {
          // 比对字段 - 只返回当前表的列
          return this.formService.schema.tables.find(t => t.tableId === sourceTableId).columns
        } else {
          // 本表字段 -返回主表和选择的表
          return this.formService.schema.tables.filter(t => t.tableId === sourceTableId || t.tableId === this.formService.formMainTableId)
        }
      }
    }
  },
  methods: {
    loadColumns () {
      this.interactions.forEach(interaction => {
        if (interaction.targetTable) {
          this.formService.loadTable(interaction.targetTable).then((columns) => {
            this.$set(interaction, 'columns', columns)
          })
        }
      })
    },
    addInteractions () {
      // 倒序展示 新增改为向头部插入数据
      this.interactions.unshift({
        id: UUID.create(),
        columns: [],
        type: [],
        expression: '',
        targetTable: '',
        compareField: '',
        formId: '',
        sourceTable: 'mainTableId',
        interactionFields: [{id: UUID.create(), firstField: '', secondField: '', relationId: '', defaultValue: ''}]
      })
      this.$nextTick(() => {
        let scrollY = this.$refs.scrollY
        scrollY.scrollTop = 0
      })
    },
    delInteractions (index) {
      this.interactions.splice(index, 1)
    },
    openCalculate (expression, interaction) {
      this.calculatePopup(expression, interaction)
    },
    addField (item) {
      item.interactionFields.push({id: UUID.create(), firstField: '', secondField: '', relationId: '', defaultValue: ''})
    },
    delField (item, i) {
      if (item.interactionFields.length !== 1) {
        item.interactionFields.splice(i, 1)
      } else {
        item.interactionFields = [{id: UUID.create(), firstField: '', secondField: '', relationId: '', defaultValue: ''}]
      }
    },
    calculatePopup (expression, interaction) {
      this.$Popup.calculation({
        parameter: {
          expression: expression,
          dataSource: this.getDataSource,
          dataSourceEnable: true,
          dataSourceReports: this.formService.options.dataSourceReports
        },
        width: '1000px',
        calculationType: 'java'
      }).then((data) => {
        if (data.action === 'confirm') {
          interaction.expression = data.value
        }
      })
    },
    expressionShow (expression) {
      if (expression) {
        return this.expressionToWithCode(expression)
      }
    },
    targetTableChange (value, interaction) {
      interaction.columns = []
      interaction.interactionFields = [{id: UUID.create(), firstField: '', secondField: '', relationId: '', defaultValue: ''}]
      if (value) {
        this.formService.loadTable(value).then((columns) => {
          interaction.columns = columns
        })
      }
    },
    // 更改源表单时，重置联动字段和比对字段信息
    resetInteractionFields (interaction) {
      interaction.compareField = ''
      interaction.interactionFields = [{id: UUID.create(), firstField: '', secondField: '', relationId: '', defaultValue: ''}]
    },
    setRelationId (value, el) {
      el.defaultValue = ''
      let component = this.formService.getComponents().find(n => n.archive.columnId === value)
      if (component) {
        let parentComponent = this.formService.getParentComponent(component)
        if (parentComponent && parentComponent.componentType === 'rc-table') {
          el.relationId = parentComponent.archive.relationId
        } else {
          el.relationId = ''
        }
      }
    },
    validate () {
      const validArr = []
      this.$refs.form && this.$refs.form.forEach((item) => {
        const result = new Promise((resolve, reject) => {
          item.validate((valid) => {
            if (valid) {
              resolve()
            } else {
              this.$message.info('数据联动必填')
              reject(new Error('数据联动必填'))
            }
          })
        })
        validArr.push(result)
      })
      return validArr
    }
  }
}
</script>

<style lang="scss">
  .data-interaction {
    main {
      max-height: 400px;
      overflow-y: auto;
      .interaction {
        margin-bottom: 10px;
        border: solid 1px #DBDBDB;
        border-radius: 4px;
        overflow: hidden;
        &:hover {
          border: solid 1px #91CBF9;
        }
        .title {
          height: 31px;
          line-height: 31px;
          background-color: var(--light-9, #EBF5FF);
          padding-left: 10px;
          color: #232323;
          position: relative;
          .del-interactions {
           position: absolute;
           font-size: 20px;
           color: #C2C3C4;
           right: 8px;
           top: 0px;
           cursor: pointer;
           display: none;
          }
           &:hover .del-interactions {
              display: block;
           }
        }

        .content {
          padding: 10px 4px;
          .el-form-item {
            margin-right: 1px;
            &.interaction-field {
              margin-left: 10px;
              margin-bottom: 6px;
              .el-select {
                margin-right: 20px;
              }
            }
            &.item-title{
             display: block;
             margin-left: 10px;
            }
            .el-tooltip {
              margin-right: 0;
            }
            &.expression-item .el-form-item__label{
              padding-left: 10px;
            }

          }
          .add-field {
            display: block;
            text-align: center;
            color: #409EFF;
            font-size: 12px;
            line-height: 28px;
            cursor: pointer;
            &:active{
              color: #388DD2
            }
          }
          .fields {
            .del-field{
              cursor: pointer;
              color: #8FA7BE;
              line-height: 28px;
              display: none;
           }
           .default-value {
             width: 350px;
             margin-left: 20px;
             margin-bottom: 18px;
           }
            &:hover .del-field{
              display: inline-block;
            }
          }

          .calculate {
            width: 150px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            height: 28px;
            padding-left: 15px;
            background: rgb(235,235,235);
            overflow-y: auto;
          }
          .el-select{
            width: 150px;
          }

        }
      }
    }

    .add-interaction {
      display: block;
      width: 103px;
      color: #54ABF1;
      cursor: pointer;
      margin:0 auto;
      margin-top: 10px;
      &:active{
        color: #388DD2
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/data-interactions.vue